import { Box, Text } from '@jfs/ui-new'

const TollTip = ({ visible, msg }: { visible: boolean; msg: string }) => {
  return (
    <>
      {visible ? (
        <Box
          borderRadius={'5px'}
          width={'175px'}
          p={'LARGE'}
          position={'absolute'}
          right={0}
          top={55}
          backgroundColor={'BLACK'}>
          <Text color={'BG_PRIMARY'}>{msg}</Text>
        </Box>
      ) : null}
    </>
  )
}

export { TollTip }
